import { LayoutDashboard, Settings, Users, LogOut } from 'lucide-react';
import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/auth-context.tsx';
import { cn } from '../../lib/utils.ts';

export function AppShell(): JSX.Element {
  const { state, logout } = useAuth();
  const userEmail = state.kind === 'authenticated' ? state.user.email : '';

  return (
    <div className="flex min-h-screen bg-bg">
      <aside className="hidden w-56 flex-col border-r border-border bg-bg-soft p-4 sm:flex">
        <div className="mb-6 px-2">
          <div className="text-base font-semibold tracking-tight">Tracker</div>
          <div className="text-xs text-fg-muted">Аналитика конверсий</div>
        </div>
        <nav className="flex-1 space-y-1">
          <NavItem to="/" icon={<LayoutDashboard className="h-4 w-4" />} label="Обзор" end />
          <NavItem to="/users" icon={<Users className="h-4 w-4" />} label="Пользователи" />
          <NavItem to="/settings" icon={<Settings className="h-4 w-4" />} label="Настройки" />
        </nav>
        <div className="space-y-2 border-t border-border pt-3">
          <div className="px-2 text-xs text-fg-muted truncate" title={userEmail}>
            {userEmail}
          </div>
          <button
            onClick={() => void logout()}
            className="btn-ghost w-full justify-start text-left"
          >
            <LogOut className="h-4 w-4" />
            Выйти
          </button>
        </div>
      </aside>

      <main className="flex-1 overflow-x-hidden">
        <div className="mx-auto max-w-6xl p-6 sm:p-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}

function NavItem({
  to,
  icon,
  label,
  end,
}: {
  to: string;
  icon: React.ReactNode;
  label: string;
  end?: boolean;
}): JSX.Element {
  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) =>
        cn(
          'flex items-center gap-2 rounded px-2 py-1.5 text-sm transition-colors',
          isActive ? 'bg-bg-elevated text-fg' : 'text-fg-muted hover:bg-bg-elevated hover:text-fg',
        )
      }
    >
      {icon}
      {label}
    </NavLink>
  );
}
